export default "__VITE_ASSET__add9912b__"